import React from 'react';
import { createRoot } from 'react-dom/client';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import './index.css';
import App from './app';

const container = document.getElementById('root');
const root = createRoot(container);

// Replace YOUR_RECAPTCHA_SITE_KEY with your actual reCAPTCHA v3 site key
const RECAPTCHA_SITE_KEY = "YOUR_RECAPTCHA_SITE_KEY"; // TODO: Replace with your actual key

root.render(
  <React.StrictMode>
    <GoogleReCaptchaProvider reCaptchaKey={RECAPTCHA_SITE_KEY}>
      <App />
    </GoogleReCaptchaProvider>
  </React.StrictMode>
);

